// Static data for imprint methods with images and descriptions
// Based on Figma design specifications
import {getColorName} from "../static_data/sections";
/**
 * Imprint method descriptions from Figma
 */
export const IMPRINT_METHOD_DESCRIPTIONS = {
  SCRE: {
    code: 'SCRE',
    name: 'Screenprint',
    description: `Your products will be Screen Printed in the ${getColorName(true)}(s) you specify. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'screenprint.png'
  },
  EMBR: {
    code: 'EMBR',
    name: 'Embroidery',
    description: `Your products will be Embroidered in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'embroidery.png'
  },
  CMYK: {
    code: 'CMYK',
    name: 'CMYK',
    description: `Your products will be imprinted in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Also known as 4 ${getColorName(true)} process, this method uses primary colours: Cyan, Magenta, Yellow and Black to produce a full ${getColorName(true)} screen printed imprint. Useful when exact ${getColorName(true)} matches are required on a full ${getColorName(true)} imprint. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'cmyk.png'
  },
  // Full Color variants
  FULL: {
    code: 'FULL',
    name: 'Full Color',
    description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'cmyk.png' // Using same image as CMYK
  },
  FULLCOLOR: {
    code: 'FULLCOLOR',
    name: 'Full Color',
    description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'cmyk.png'
  },
  FC: {
    code: 'FC',
    name: 'Full Color',
    description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'cmyk.png'
  },
  DTG: {
    code: 'DTG',
    name: 'DTG',
    description: `Your products will be printed Direct-to-Garment in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Full ${getColorName(true)} inks are jetted or sprayed onto the textile by the print head. The inks soak into the garment fibers directly and then it is sealed with heat. It's like printing on paper, but on fabric! You can make intricate colourful designs with many details, and photo-realistic artwork. Preferred imprint method for many apparel options. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
    image: 'dtg.png'
  }
};

/**
 * Get imprint method description by SKU
 * Extracts method code from SKU (e.g., '3001C_SCRE' -> 'SCRE')
 * @param {string} sku - Product SKU
 * @returns {Object|null} Method description object
 */
export function getImprintMethodBySku(sku) {
  if (!sku) return null;
  
  // Extract method code from SKU (last part after underscore)
  const parts = sku.split('_');
  const methodCode = parts[parts.length - 1];
  
  return IMPRINT_METHOD_DESCRIPTIONS[methodCode] || null;
}

/**
 * Get imprint method image path
 * @param {string} sku - Product SKU
 * @returns {string|null} Image filename or null
 */
export function getImprintMethodImage(sku) {
  const method = getImprintMethodBySku(sku);
  return method ? method.image : null;
}

/**
 * Get imprint method description text
 * @param {string} sku - Product SKU
 * @returns {string} Description text or empty string
 */
export function getImprintMethodDescription(sku) {
  const method = getImprintMethodBySku(sku);
  return method ? method.description : '';
}

export function getFallbackDescription(sku) {
  const descriptions = {
    SCRE: 'Your products will be Screen Printed in the colour(s) you specify.',
    EMBR: 'Your products will be Embroidered with your custom design.',
    DTG: 'Your products will be printed using Direct-to-Garment (DTG) technology.',
    DTF: 'Your products will be printed using Direct-to-Film (DTF) technology.',
    CMYK: 'Your products will be printed in full color using CMYK printing technology.',
    FULL: 'This is a printing technique that transfers vibrant, full-color designs onto fabrics.',
    FULLCOLOR: 'This is a printing technique that transfers vibrant, full-color designs onto fabrics.',
    FC: 'This is a printing technique that transfers vibrant, full-color designs onto fabrics.'
  };

  const parts = (sku || '').split('_');
  const methodCode = parts[parts.length - 1];
  return descriptions[methodCode] || 'Your products will be customized with your design.';
}
